module.exports = __webpack_public_path__ + "img/4.5a2eb3d7.png";